import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { Container, Row } from "reactstrap";
import { LabelValue } from "@/Component/Value";
import { useOneHouseCampaignsGroupsContractQuery, useOneHouseContractQuery } from "@/services/housing";
import { Col } from "react-bootstrap";
import { Divider, Tag } from "antd";
import TableC from "@/CommonElements/TableC";
import { useLocalizedText } from "@/utils/hooks/useLocalizedText";
import { useCachedBasicData } from "@/utils/hooks/useCachedBasicData";
import { Link } from "react-router-dom";
import { SelectCountry } from "@/Component/Form/SelectCountry";
import { toast } from "react-toastify";

export const ViewHousingContract = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { getLocalizedDate, getLocalizedText, getLocalizedNumber } = useLocalizedText();
  const { cachedBasicData } = useCachedBasicData();

  const contract = cachedBasicData.contracts.find((contract) => contract.id === id);
  const {
    data: oneHouseContract,
    isLoading: isOneHouseContractLoading,
    isFetching: isOneHouseContractFetching,
  } = useOneHouseContractQuery();

  const {
    data: oneHouseCampaignsGroupsContract,
    isLoading: isOneHouseCampaignsGroupsContractLoading,
    isFetching: isOneHouseCampaignsGroupsContractFetching,
  } = useOneHouseCampaignsGroupsContractQuery();

  const campaignsGroupsContractLoading =
    isOneHouseCampaignsGroupsContractLoading || isOneHouseCampaignsGroupsContractFetching;

  const campaignsGroupsContract = oneHouseCampaignsGroupsContract?.data?.data;

  const oneHouseContractData = oneHouseContract?.data?.data;
  const loading = isOneHouseContractLoading || isOneHouseContractFetching;

  const LABLEVALUE = ({ label, value }) => (
    <Col xs={6} md={3} lg={4} className="mb-3">
      <LabelValue direction="vertical" loading={loading} label={label} value={value || "-"} />
    </Col>
  );

  const isCampaignSourceType = (sourceType) => {
    const source_type = (sourceType ?? "CAMPAIGN")?.toUpperCase();

    return source_type === "CAMPAIGN";
  };

  // const source_type = (campaignsGroupsContract?.contracts?.[0]?.source_type ?? "CAMPAIGN")?.toUpperCase();

  // const isCampaign = source_type === "CAMPAIGN";
  const columns = [
    {
      name: t(`NUMBER`),
      key: "number",
      render: (value, rowData) => (
        <Link
          className="fw-bold"
          to={
            isCampaignSourceType(rowData.source_type)
              ? `/app/makkah/arrival-campaign/${rowData.id}/JED/view`
              : `/app/makkah/groups-upcoming/${rowData.group_id}/view`
          }
        >
          <span>{getLocalizedNumber(rowData.number)}</span>
        </Link>
      ),
    },
    {
      name: t(`NAME`),
      key: "name", //isCampaign ? "campaign_name" : "group_name",
      render: (value, rowData) => (
        // copy on click
        <div
          className="fw-bold mx-auto"
          title={value}
          style={{
            maxWidth: "170px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
          onClick={() => {
            navigator.clipboard.writeText(value);
            toast.success(t("COPIED_TO_CLIPBOARD"), { position: "top-right" });
          }}
        >
          {value}
        </div>
      ),
    },
    {
      name: t("COUNTRY"),
      key: "country_id",
      render: (value) => <SelectCountry.Display value={value} />,
    },
    {
      name: t("SERVICE_CENTER"),
      key: getLocalizedText("service_center_name_ar", "service_center_name_en"),
    },
    {
      name: t("PILGRIMS_COUNT"),
      key: "capacity",
    },
    {
      name: t("CONTRACT_START_DATE"),
      key: "contractStartDate",
      render: (value) => getLocalizedDate(value),
    },
    {
      name: t("CONTRACT_END_DATE"),
      key: "contractEndDate",
      render: (value) => getLocalizedDate(value),
    },
  ];

  return (
    <div>
      <PageHeader title={t("HOUSING_CONTRACTS")} sticky={false} />
      <Container fluid>
        <Row>
          <LABLEVALUE label={t("BUILDING_NUMBER")} value={oneHouseContractData?.house?.BuildingNo} />
          <LABLEVALUE label={t("BUILDING_ZONE_NUMBER")} value={oneHouseContractData?.house?.AreaNo} />
          <LABLEVALUE label={t("BUILDING_CODE")} value={oneHouseContractData?.house?.id} />
          <LABLEVALUE label={t("BUILDING_NAME")} value={oneHouseContractData?.house?.BuildingName} />
          <LABLEVALUE label={t("PERMIT_NO")} value={oneHouseContractData?.house?.permit_no} />
          <LABLEVALUE label={t("CITY")} value={oneHouseContractData?.cityName} />
          <LABLEVALUE label={t("ADDRESS_LABEL")} value={oneHouseContractData?.house?.HOUSE_ADDRESS_1} />
          <LABLEVALUE label={t("BUILDING_DELEGATE")} value={oneHouseContractData?.house?.OwnerName} />
          <LABLEVALUE label={t("MOBILE_NUMBER")} value={oneHouseContractData?.house?.REP_MOBILE_NO} />
          <LABLEVALUE
            label={t("ORGANIZER")}
            value={getLocalizedText(oneHouseContractData?.missionNameAr, oneHouseContractData?.missionNameEn)}
          />
          <LABLEVALUE
            label={t("AFFILIATED_ORGANIZER")}
            value={getLocalizedText(oneHouseContractData?.companyNameAr, oneHouseContractData?.companyNameEn) || "-"}
          />
          <LABLEVALUE label={t("CONTRACT_START_DATE")} value={oneHouseContractData?.contractStartDate} />
          <LABLEVALUE label={t("CONTRACT_END_DATE")} value={oneHouseContractData?.contractEndDate} />
          <LABLEVALUE
            label={t("FOOD_SERVICE_INCLUDED")}
            value={+oneHouseContractData?.isFoodServiceIncluded ? t("YES") : t("NO")}
          />
          <LABLEVALUE label={t("PILGRIMS_COUNT")} value={oneHouseContractData?.numberOfPilgrims} />
        </Row>

        <Divider />

        <TableC
          loading={campaignsGroupsContractLoading}
          columnsFilter={false}
          data={campaignsGroupsContract?.contracts || []}
          columns={columns}
        />
      </Container>
    </div>
  );
};
